import { render, staticRenderFns } from "./DashboardVolunteer.vue?vue&type=template&id=14c63e43&"
import script from "./DashboardVolunteer.vue?vue&type=script&lang=ts&"
export * from "./DashboardVolunteer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports